<div *ngIf="(editMode && !readonly) && testType !== 'POLL'" class="result form"
     [class.correct]="form.controls.isCorrect.value !== null && form.controls.isCorrect.value"
     [class.wrong]="form.controls.isCorrect.value !== null && !form.controls.isCorrect.value">
  <form [formGroup]="form" (ngSubmit)="onSubmit($event)">
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Результат</mat-label>
        <mat-select formControlName="isCorrect"
                    [required]="true"
                    [value]="questionResult.isCorrect">
          <mat-option [value]="true">Правильно</mat-option>
          <mat-option [value]="false">Неправильно</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Комментарий</mat-label>
        <textarea matInput
                  formControlName="comment"
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="3"
                  cdkAutosizeMaxRows="6"></textarea>
      </mat-form-field>
    </div>
    <div class="buttons">
      <button mat-button
              *ngIf="questionResult.isCorrect !== null"
              type="button"
              (click)="onCancel($event)">Отмена
      </button>
      <button mat-flat-button
              color="primary"
              type="submit"
              (click)="onSubmit($event)">Сохранить
      </button>
    </div>
  </form>
</div>

<div *ngIf="(!editMode || readonly) && testType !== 'POLL'" class="result"
     [class.correct]="questionResult.isCorrect !== null && questionResult.isCorrect"
     [class.wrong]="questionResult.isCorrect !== null && !questionResult.isCorrect">
  <div class="header">
    <div class="label">
      <ng-template [ngIf]="questionResult.isCorrect !== null && questionResult.isCorrect">
        <mat-icon class="icon">check</mat-icon>
        <div class="text">Правильно</div>
      </ng-template>
      <ng-template [ngIf]="questionResult.isCorrect !== null && !questionResult.isCorrect">
        <mat-icon class="icon">close</mat-icon>
        <div class="text">Неправильно</div>
      </ng-template>
      <ng-template [ngIf]="questionResult.isCorrect === null">
        <mat-icon class="icon">help_outline</mat-icon>
        <div class="text">Непроверен</div>
      </ng-template>
    </div>
    <button mat-icon-button *ngIf="!readonly"
            class="edit-button"
            matTooltip="Изменить"
            (click)="setEditMode(true)">
      <mat-icon>edit</mat-icon>
    </button>
  </div>
  <div *ngIf="questionResult.comment"
       class="comment-container">
    <div class="label">Комментарий</div>
    <div class="text">{{questionResult.comment}}</div>
  </div>
</div>
